/**
 * Transaction user type (who performed the transaction)
 */
export enum TransactionUserType {
  REPRESENTATIVE = 'REPRESENTATIVE',
  ADMIN = 'ADMIN',
  SYSADMIN = 'SYSADMIN',
  SYSTEM = 'SYSTEM',
}
